// extracted by mini-css-extract-plugin
module.exports = {"indexContents":"index-module--index-contents--1EobF","shadowedText":"index-module--shadowed-text--1YFVG"};